(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("leaflet"), require("leaflet.markercluster"), require("vue2-leaflet"));
	else if(typeof define === 'function' && define.amd)
		define(["leaflet", "leaflet.markercluster", "vue2-leaflet"], factory);
	else if(typeof exports === 'object')
		exports["Vue2LeafletMarkercluster"] = factory(require("leaflet"), require("leaflet.markercluster"), require("vue2-leaflet"));
	else
		root["Vue2LeafletMarkercluster"] = factory(root["leaflet"], root["leaflet.markercluster"], root["vue2-leaflet"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition